import { useState, useEffect, useContext } from "react";
import { motion } from "motion/react";
import { Star,  Trees, Mountain, Sprout } from "lucide-react";
import styles from "./LevelMap.module.css";
import gameIcon from "../assets/gamelevel.png";
import { ArrowLeft } from "lucide-react"; 
import { useNavigate } from "react-router-dom"; 
import { LanguageContext } from "./LanguageContext";
import { LEVEL_MAP, pageT } from "../utils/i18n"; 


export function LevelMap() {




  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, LEVEL_MAP);

  const goBack = () => {
    navigate(-1); 
  };


  const levels = Array.from({ length: 50 }, (_, i) => i + 1);

  const getRewardForLevel = (level) => {
    if (level === 10) return { title: t.silver, type: "silverEnvelope" };
    if (level === 20) return { title: t.golden, type: "goldEnvelope" };
    if (level === 30) return { title: t.diamond, type: "diamondEnvelope" };
    if (level === 50) return { title: t.trophy, type: "trophy" };
    return null;
  };

  const isRewardLevel = (level) => !!getRewardForLevel(level);

  const getDecoration = (index) => {

    if (index % 3 === 0) return { type: 'tree', Component: Trees, size: 40, offset: { top: -20, left: -60 } };
    if (index % 4 === 0) return { type: 'grass', Component: Sprout, size: 24, offset: { top: 10, left: 40 } };
    if (index % 5 === 0) return { type: 'stone', Component: Mountain, size: 30, offset: { top: 30, right: -50 } };
    if (index % 2 === 0 && index % 3 !== 0) return { type: 'grass', Component: Sprout, size: 20, offset: { top: -10, right: 35 } };
    return null;
  };

  const handleLevelClick = (level) => {
    if (level === 10) {
      navigate("/silverchit");
    } else if (level === 20) {
      navigate("/goldenchit");
    } else if (level === 30) {
      navigate("/diamondchit"); 
    } else if (level === 50) {
      navigate("/gamefinish");
    } else {
      navigate(`/levelpage/${level}`);
    }
  };

  return (
    <div
      className={styles.container} >
      <div className={styles.backArrow} onClick={goBack}>
        <ArrowLeft size={30} />
      </div>
      <motion.img
        src={gameIcon}
        alt="Chit Puzzle Game Icon"
        className={styles.gameIcon}
        animate={{ scale: [1, 1.05, 1] }}
        transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <p className={styles.subHeader}>{t.subHeader}</p>

      <div className={styles.levelWrapper}>
        {levels.map((level, index) => {
          const reward = getRewardForLevel(level);
          const decoration = getDecoration(index);

          return (
            <div
              key={level}
              className={styles.levelContainer}
              onClick={() => handleLevelClick(level)}
              style={{ cursor: "pointer" }}
            >

              {/* Decorations */}
              {decoration && (
                <div
                  className={`${styles.decoration} ${styles[decoration.type]}`}
                  style={{
                    top: decoration.offset.top,
                    left: index % 2 === 0 ? decoration.offset.left : undefined,
                    right: index % 2 !== 0 ? decoration.offset.right : undefined, 
                    [index % 2 === 0 ? 'left' : 'right']: 60 + Math.abs(decoration.offset.left || decoration.offset.right || 0) + 'px'
                  }}
                >
                  <decoration.Component size={decoration.size} />
                </div>
              )}


             
              {reward && reward.type.includes('Envelope') && (
                <div className={`${styles.envelopeContainer} ${styles[reward.type]}`}>
                  <div className={styles.envelopeBody}>
                    <div className={styles.envelopeFlap}></div>
                  </div>
                  <span className={styles.chitTitle}>{reward.title}</span>
                </div>
              )}

              
              {reward && reward.type === 'trophy' && (
                <motion.div
                  className={`${styles.rewardChit} ${styles[reward.type]}`}
                  animate={{ y: [0, -10, 0] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                >
                  <div className={styles.coinFace}>
                    <span className={styles.chitIcon}>🏆</span>
                  </div>
                  <span className={styles.chitTitle}>{reward.title}</span>
                </motion.div>
              )}


           
              <motion.div
                className={`${styles.levelCircle} ${isRewardLevel(level) ? styles.rewardLevel : ""}`}
                animate={isRewardLevel(level) ? { scale: [1, 1.2, 1] } : {}}
                transition={{ duration: 1.5, repeat: Infinity }}
              >
                {level}
                {isRewardLevel(level) && (
                  <Star className={styles.levelStar} size={18} />
                )}
              </motion.div>
            </div>
          );
        })}
      </div>

      <div className={styles.floating_shapes}>
        <span></span><span></span><span></span><span></span><span></span>
      </div>
    </div>
  );
}
